(() => {
  if (window.hcGiftSearchImages) return;
  window.hcGiftSearchImages = true;
  const requests = new Map();
  async function refresh(card) {
    try {
      const url = new URL(card.dataset.hcGiftSearch, location.origin);
      if (url.origin !== location.origin || !url.pathname.endsWith('/search') || !url.searchParams.get('q')) return;
      const destination = url.pathname + url.search;
      url.searchParams.set('section_id', 'hc-gift-search-image');
      const key = url.href;
      if (!requests.has(key)) requests.set(key, fetch(key).then(response => {
        if (!response.ok) throw new Error('Gift image unavailable');
        return response.text();
      }));
      const doc = new DOMParser().parseFromString(await requests.get(key), 'text/html');
      const result = doc.querySelector('[data-hc-gift-result]');
      const image = result && result.querySelector('img');
      const link = card.querySelector('.hc-gift-image-link');
      if (!image || !link || !card.isConnected) return;
      const replacement = document.importNode(image, true);
      replacement.loading = 'eager';
      await replacement.decode();
      link.replaceChildren(replacement);
      link.href = destination;
      card.dataset.hcGiftProduct = result.dataset.hcGiftResult;
    } catch (_) { /* Keep the collection image if search or image loading fails. */ }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      refresh(entry.target);
    });
  }, { rootMargin: '400px' }) : null;
  function init(root) {
    root.querySelectorAll('[data-hc-gift-search]').forEach(card => {
      if (card.dataset.hcGiftObserved) return;
      card.dataset.hcGiftObserved = 'true';
      if (observer) observer.observe(card); else refresh(card);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
